export const environment = {
  production: true,
  ScienceApi: 'https://api.agric.wa.gov.au/v2/science/',
  ScienceApiKey: 'NWw4nM3KOW8Y8wwJY3Nn6J3HCzIdnVg8'
};
